import { Grid, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { GiHamburgerMenu } from 'react-icons/all';
import { Link, useLocation } from 'react-router-dom';
import { NoPaddingButton } from '../../../components/NoPaddingButton/NoPaddingButton';
import { useSponsorsProvider } from '../Context/SponsorsMainContext';
import Logo from '../../../assets/img/zivot.svg';
import SponsorsOptionsDropdown from './OptionsDropdown';

interface NavbarProps {
  backButton?: boolean;
  handleBack?: () => void;
}

const SponsorsNavbar = ({ backButton, handleBack }: NavbarProps): JSX.Element => {
  const { user, menuOpen, setMenuOpen, sponsor } = useSponsorsProvider();
  const muiTheme = useTheme();
  const mobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const location = useLocation();
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: menuOpen ? '15rem' : '0',
        transition: 'left 0.5s, right 0.5s',
        transitionTimingFunction: 'ease-out',
        right: menuOpen ? '-15rem' : '0',
        zIndex: 1000,
      }}
    >
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
        style={{
          backgroundColor: 'white',
          border: '1px solid #DFE1E3',
          boxShadow: '0px 2px 10px rgba(0, 24, 102, 0.05)',
          position: 'relative',
        }}
      >
        <Grid item xs={3}>
          {user && sponsor ? (
            <NoPaddingButton
              style={{ marginLeft: '1.5rem' }}
              onClick={() => setMenuOpen(true)}
            >
              <GiHamburgerMenu
                style={{ color: 'black', fontSize: '1.5rem', marginRight: '1rem' }}
              />
            </NoPaddingButton>
          ) : null}
        </Grid>

        <Grid item xs={6} style={{ textAlign: 'center' }}>
          <Tooltip title='Ir a inicio' placement='bottom'>
            <Link
              to={{
                pathname: '/',
                search: location.search,
              }}
            >
              <img
                src={Logo}
                alt='Logo codigo médico'
                style={{ height: mobile ? '3.5rem' : '5rem', margin: '0.5rem' }}
              />
            </Link>
          </Tooltip>
        </Grid>

        <Grid item xs={3}>
          <Grid container direction='row' justifyContent='flex-end' alignItems='center'>
            {user ? <SponsorsOptionsDropdown /> : null}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

SponsorsNavbar.defaultProps = {
  backButton: false,
  handleBack: () => {},
};

export default SponsorsNavbar;
